<template>
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">

<nav class="navbar navbar-expand-lg navbar-light bg-white py-3">
  <div class="container">
    <a class="navbar-brand" href="#">
      <img src="../../assets/logo2.png" alt="Logo neolinks" class="logo">
    </a>
    
    <!-- MOBILE SEULEMENT : Boutons de langue + Menu hamburger -->
    <div class="d-flex align-items-center gap-2 d-lg-none">
      <!-- Language Switcher - MOBILE SEULEMENT -->
      <LanguageSwitcher />
      
      <!-- Menu hamburger -->
      <button class="navbar-toggler" 
        type="button" 
        :class="{ 'active': isMenuOpen }"
        @click="toggleMenu">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    
    <div class="collapse navbar-collapse" id="navbarNav" :class="{ 'show': isMenuOpen }">
      <ul class="navbar-nav mx-auto">
        <li class="nav-item">
          <a class="nav-link" href="#home" @click="closeMenu">{{ t('menu.home') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#features" @click="closeMenu">{{ t('menu.features') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#pricing" @click="closeMenu">{{ t('menu.pricing') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#faq" @click="closeMenu">{{ t('menu.faq') }}</a>
        </li>
      </ul>

      <!-- DESKTOP SEULEMENT : Boutons de langue + CTA Button -->
      <div class="d-none d-lg-flex align-items-center gap-2">
        <!-- Language Switcher - DESKTOP SEULEMENT -->
        <LanguageSwitcher />
        
        <!-- CTA Button -->
        <router-link to="/inscription" class="btn btn-primary btn-fixed-width">
          {{ t('button.getYourNeolink') }}
        </router-link>
      </div>

      <!-- CTA Button - Mobile (dans le menu) -->
      <div class="d-lg-none mt-3">
        <router-link to="/inscription" class="btn btn-primary w-100" @click="closeMenu">
          {{ t('button.getYourNeolink') }}
        </router-link>
      </div>
    </div>
  </div>
</nav>
</template>

<script>
import { useTranslation } from '@/composables/useTranslation'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

export default {
  name: 'Header',
  components: {
    LanguageSwitcher
  },
  setup() {
    const { t } = useTranslation()
    
    return {
      t
    }
  },
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    }
  }
}
</script>

<!-- TON CSS RESTE IDENTIQUE -->
<!-- TON CSS RESTE IDENTIQUE -->
  
  <style lang="scss" scoped>
  .navbar {
    transition: 0.3s;
  
    &-brand img {
      height: 32px;
    }
  
    .nav-link {
      color: #333;
      font-weight: 500;
      transition: 0.3s;
  
      &:hover {
        color: var(--bs-primary);
      }
    }
  }
  
  @media (max-width: 991px) {
    .navbar-collapse {
      padding: 1rem 0;
    }
  }

  .btn-fixed-width {
  width: auto;
  min-width: 200px;
  white-space: nowrap;
}
  body {
            font-family: 'Arial', sans-serif;
            color: #333;
            background-color: #fff;
        }
    
        /* Typography Scale */
        .display-1 { font-size: calc(2rem + 3vw); }
        .display-2 { font-size: calc(1.8rem + 2.4vw); }
        .display-3 { font-size: calc(1.6rem + 1.8vw); }
        .display-4 { font-size: calc(1.4rem + 1.2vw); }
        .display-5 { font-size: calc(1.2rem + 0.6vw); }
        .display-6 { font-size: calc(1rem + 0.3vw); }
    
        .lead {
            font-size: calc(1rem + 0.2vw);
            line-height: 1.6;
        }
    
        /* Responsive text adjustments */
        @media (max-width: 768px) {
            .hero-section h1 {
                font-size: calc(1.8rem + 1.5vw);
                line-height: 1.2;
            }
            .lead {
                font-size: 1rem;
            }
            .section-title {
                font-size: calc(1.5rem + 1vw);
            }
            .card-title {
                font-size: 1.25rem;
            }
        }
    
        /* Component styles */
        .navbar-brand img {
            height: 32px;
        }
    
        .btn-primary {
            background-color: #000;
            border-color: #000;
            transition: all 0.3s ease;
            padding: 0.5rem 1.5rem;
        }
    
        .btn-primary:hover {
            background-color: #333;
            border-color: #333;
        }
    
        .btn-outline-primary {
            color: #000;
            border-color: #000;
            transition: all 0.3s ease;
        }
    
        .btn-outline-primary:hover {
            background-color: #000;
            color: #fff;
            border-color: #000;
        }
    
    .navbar-toggler {
  &:focus { box-shadow: none; }
  
  .navbar-toggler-icon {
    background-image: none;
    width: 20px; height: 2px; background: #333;
    position: relative; transition: 0.3s;
    
    &::before, &::after {
      content: ''; position: absolute; width: 20px; height: 2px; background: #333; transition: 0.3s;
    }
    &::before { top: -6px; }
    &::after { top: 6px; }
  }
  
  &.active .navbar-toggler-icon {
    background: transparent;
    &::before { transform: rotate(45deg); top: 0; }
    &::after { transform: rotate(-45deg); top: 0; }
  }
}
  </style>